{
  "commons": {
    "open": "Pendente",
    "inProgress": "Em andamento"
  },
  "loader": {
    "message": "Aguarde, por favor..."
  },
  "validations": {
    "generic-error": "Algo deu errado"
  },
  "assembly": {
    "title": "Montagem"
  }
}